var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.panelVisible)?_c('div',{staticClass:"l-navigation"},[_c('div',{staticClass:"header",on:{"click":_vm.toggole}},[_c('span',{staticClass:"icon-arrowright"}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(this.$route.meta.panelTitle)}})]),_vm._v(" "),_c('div',{staticClass:"main"},[_vm._t("default")],2)]):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16910483","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/views/layouts/l-navigation.vue
// module id = 668
// module chunks = 0